import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Trainer extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Trainer';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'school', 'trainer', 'phone', 'roles', 'parnassys_id'];
        this.filters = {
            role: 'trainer',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/trainers/' + this.id;
    }
}
